import {
  invalidateAll as invalidateAllNavigation,
  invalidate as invalidateNavigation
} from '$app/navigation';
import { debounceAsync } from '@repo/toolslib/src/utils/debounce.util';

export const invalidate = debounceAsync(
  async (name: string) => {
    await invalidateNavigation(name);
  },
  'invalidate',
  1000
);

export const invalidateAll = debounceAsync(
  async () => {
    await invalidateAllNavigation();
  },
  'invalidateAll',
  1000
);
